module.exports = __webpack_public_path__ + "img/pass_2.00740b23.png";